import { bindKeyboardFocusRing } from './shared-focus-visible';

export default function searchJobs(root: HTMLElement): void {
  const field = root.querySelector<HTMLElement>('.search-jobs__field');
  const input = root.querySelector<HTMLInputElement>('.search-jobs__input');
  const clearButton = root.querySelector<HTMLButtonElement>('.search-jobs__clear');
  const submitButton = root.querySelector<HTMLButtonElement>('.search-jobs__submit');

  if (!field || !input || !clearButton || !submitButton) return;

  function updateControlState(): void {
    const hasTerm = input!.value.trim().length > 0;
    submitButton!.disabled = !hasTerm;
    clearButton!.hidden = !hasTerm;
  }

  input.addEventListener('input', updateControlState);

  clearButton.addEventListener('click', () => {
    input.value = '';
    updateControlState();
    input.focus();
  });

  updateControlState();

  bindKeyboardFocusRing(input, field, 'search-jobs__field--focus-ring');
}
